import { getRequestOptions, token } from './ServiceHelper';

const API_ENV = process.env.REACT_APP_API_ENV ?? '';

interface ProblemDetails {
  detail?: string;
  errorMessage?: string;
  message?: string;
  title?: string;
}

export class AccountProvisioningError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'AccountProvisioningError';
    this.status = status;
    Object.setPrototypeOf(this, AccountProvisioningError.prototype);
  }
}

export async function applyAccountProvisioningDefaults(accountId: string): Promise<void> {
  if (token() === null) {
    throw new AccountProvisioningError('Unauthorised.', 401);
  }

  const response = await fetch(
    `${API_ENV}/account/${accountId}/v1/provisioning-defaults`,
    getRequestOptions('PUT')
  );

  if (response.ok) {
    return;
  }

  let details: ProblemDetails | null = null;
  try {
    details = (await response.json()) as ProblemDetails;
  } catch {
    details = null;
  }

  const message =
    details?.detail ??
    details?.errorMessage ??
    details?.message ??
    details?.title ??
    'Unable to apply account provisioning defaults.';

  throw new AccountProvisioningError(message, response.status);
}
